import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;

export function fetchRestaurants() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = fetch(`${API}/api/restaurants`)
      .then(r => (r.ok ? r.json() : { restaurants: [], updated_at: null }))
      .then(d => { cache = d; return d; })
      .catch(() => ({ restaurants: [], updated_at: null }))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useRestaurants() {
  const [data, setData] = useState(cache || { restaurants: [], updated_at: null, loading: true });
  useEffect(() => {
    let alive = true;
    fetchRestaurants().then(d => { if (alive) setData({ ...d, loading: false }); });
    return () => { alive = false; };
  }, []);
  return data;
}

export const restaurantDesc = (r, language) => (language === 'ar' ? (r.desc_ar || r.desc_en) : r.desc_en);

export const diningCardRestaurants = (restaurants) => restaurants.filter(r => r.card_category);
